module.exports = __webpack_public_path__ + "img/bule3.f7f863d0.png";